// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"dissmisable-alert_alertWrapper__2sXb5","fixed":"dissmisable-alert_fixed__Z-saa","alert":"dissmisable-alert_alert__3GGMl"};